export const types = {
    SHOW_TOAST: "SHOW_TOAST",
    SHOW_LOADER: "SHOW_LOADER",
    HIDE_LOADER: "HIDE_LOADER",
    USER_DETAIL: "USER_DETAIL",
    USERS: "USERS",
    SERVCIES: "SERVCIES",
    SUB_SERVCIES: "SUB_SERVCIES",
    SERVICE_DETAILS: "SERVICE_DETAILS",
    ORDERS: "ORDERS",
    ORDER_DETAILS: "ORDER_DETAILS",
    STYLE_GUIDES: "STYLE_GUIDES",
    STYLE_GUIDES_DETAILS: "STYLE_GUIDES_DETAILS",
    OUR_WORK_LIST: "OUR_WORK_LIST",
    OUR_WORK_DETAILS: "OUR_WORK_DETAILS",
    TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
    PRIVACY_POLICY: "PRIVACY_POLICY",
    FAQ: "FAQ",
    CONTACTS: "CONTACTS",
    CONTACT_DETAILS: "CONTACT_DETAILS",
    ENQUIRIES: "ENQUIRIES",
    ENQUIRIES_DETAILS: "ENQUIRIES_DETAILS",
    OUR_CLIENTS: "OUR_CLIENTS"
};
